export const createEmptyFieldText = (field: string): string => `This field is filled incorrectly`;
export const createPasswordMismatchText = (): string => `Passwords do not match`;
export const createLocationSelectText = (field: string): string =>
  `Please select location from list`;
